import { AmbassadorToggleProps } from './ambassador-toggle.props';
import { CSSTransition } from 'react-transition-group';
import React, { useState } from 'react';
import { useAmbassadorToggleStyles } from '../../../styles/molecules/ambassador-toggle.styles';

export const AmbassadorToggleMolecule = (props: AmbassadorToggleProps) => {
  const [ambassadorOpened, openAmbassador] = useState(false);
  const classes = useAmbassadorToggleStyles();

  function toggleAmbassador() {
    openAmbassador(!ambassadorOpened);
  }

  return (
    <div
      data-cy="data-toggle-molecule"
      className="w-full py-2.5 mt-0 lg:mt-10 relative z-20"
    >
      <div
        className={`flex flex-row w-full justify-end md:justify-start lg:justify-start ${props.display}`}
      >
        <div
          className="w-8 block cursor-pointer text-2xl outline-none focus:outline-none focus:shadow-none shadow-none box-border"
          onClick={toggleAmbassador}
        >
          {ambassadorOpened ? (
            <>
              <img
                src="/images/icons/doctor-ambassador/toggle-close.svg"
                alt="close"
              />
            </>
          ) : (
            <>
              <img
                src="/images/icons/doctor-ambassador/toggle-open.svg"
                alt="open"
              />
            </>
          )}
        </div>
        <h2 className="text-waldo-blue text-3xl ml-2 leading-8 pt-1">
          {props.title}
        </h2>
      </div>

      <CSSTransition
        mountOnEnter
        unmountOnExit
        timeout={250}
        in={ambassadorOpened}
        classNames={'article-transition'}
      >
        <div
          className={`w-full flex flex-row justify-end lg:justify-start text-waldo-blue   ${classes['article-transition']}`}
        >
          <div
            className={`shadow-md px-4 py-4 lg:py-5 text-regular bg-white ${props.boxStyling}`}
          >
            <p className="text-regular leading-4.5 lg:text-lg lg:leading-5.5 ">
              {props.content}
            </p>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
